// extracted by mini-css-extract-plugin
export default {"incluye":"Incluye_incluye__yzEGI","progressContainer":"Incluye_progressContainer__lswz+","progressBar":"Incluye_progressBar__PVZeO","scrollContent":"Incluye_scrollContent__gD6Ei"};